import Papa from "papaparse";
import { identity } from "ramda";

const formatFn = (headers, format) => object =>
  headers.map(key => (format[key] || identity)(object[key]));

export default async ({ headers, query, format = {} }) => {
  const result = await query;

  if (!result.success) {
    return result;
  }

  const fields = Object.values(headers);
  const data = result.data.map(formatFn(Object.keys(headers), format));

  return {
    success: true,
    data: Papa.unparse({ data, fields })
  };
};



// WEBPACK FOOTER //
// ./src/util/csv-from.js